import { AUTHORITIES } from '../store/modules/auth';
import { CONST } from '../utils/constants';

export interface ApplicationUserPermissions {
  id: string;
  applicationUserId: string;
  companyId: string;

  homeConflictsViewEdit: boolean;
  homeTodoViewEdit: boolean;
  homeNewsView: boolean;
  homeNewsCreateDelete: boolean;
  homeNewsEdit: boolean;
  homeReportsView: boolean;
  homeCalendarEdit: boolean;
  homeCalendarChatUse: boolean;

  locationsView: boolean;
  locationsCreateDelete: boolean;
  locationsEdit: boolean;

  employeesView: boolean;
  employeesCreateDelete: boolean;
  employeesEdit: boolean;

  trainersView: boolean;
  trainersCreateDelete: boolean;
  trainersEdit: boolean;

  coursesView: boolean;
  coursesCreateDelete: boolean;
  coursesEdit: boolean;
  dateTimesView: boolean;
  dateTimesEdit: boolean;
  appointmentsView: boolean;
  appointmentsCreateDelete: boolean;
  appointmentsEdit: boolean;

  invoicesView: boolean;
  invoicesEdit: boolean;
  invoicePositionsView: boolean;
  invoicePositionsEdit: boolean;
  invoiceRunsView: boolean;
  invoiceRunsCreateDelete: boolean;
  trainerPayrollsView: boolean;
  trainerPayrollsEdit: boolean;
  directDebitViewCreate: boolean;

  attendeesView: boolean;
  attendeesCreateDelete: boolean;
  attendeesEdit: boolean;
  interestedView: boolean;
  interestedCreateDelete: boolean;
  interestedEdit: boolean;

  statisticsViewCreate: boolean;
  myCompanyViewEdit: boolean;
  companySubscriptionsViewEdit: boolean;
  settingsViewEdit: boolean;

  referencesView: boolean;
  tariffsCreateDelete: boolean;
  tariffsEdit: boolean;
  departmentsCreateDelete: boolean;
  departmentsEdit: boolean;
  membershipTypesCreateDelete: boolean;
  membershipTypesEdit: boolean;
  memberStatusesCreateDelete: boolean;
  memberStatusesEdit: boolean;
  costsCreateDelete: boolean;
  costsEdit: boolean;
  licencesCreateDelete: boolean;
  licencesEdit: boolean;
  skillsCreateDelete: boolean;
  skillsEdit: boolean;
  characteristicsCreateDelete: boolean;
  characteristicsEdit: boolean;
  equipmentsCreateDelete: boolean;
  equipmentsEdit: boolean;
  attendeeRolesEdit: boolean;
  attendeeRolesCreateDelete: boolean;
}

function toAPI(data: Partial<ApplicationUserPermissions>): any {
  return {
    Id: data?.id || CONST.emptyGuid,
    ApplicationUserId: data?.applicationUserId || CONST.emptyGuid,
    CompanyId: data?.companyId || CONST.emptyGuid,

    HomeConflictsViewEdit: data?.homeConflictsViewEdit ?? false,
    HomeTodoViewEdit: data?.homeTodoViewEdit ?? false,
    HomeNewsView: data?.homeNewsView ?? false,
    HomeNewsCreateDelete: data?.homeNewsCreateDelete ?? false,
    HomeNewsEdit: data?.homeNewsEdit ?? false,
    HomeReportsView: data?.homeReportsView ?? false,
    HomeCalendarEdit: data?.homeCalendarEdit ?? false,
    HomeCalendarChatUse: data?.homeCalendarChatUse ?? false,

    LocationsView: data?.locationsView ?? false,
    LocationsCreateDelete: data?.locationsCreateDelete ?? false,
    LocationsEdit: data?.locationsEdit ?? false,

    EmployeesView: data?.employeesView ?? false,
    EmployeesCreateDelete: data?.employeesCreateDelete ?? false,
    EmployeesEdit: data?.employeesEdit ?? false,

    TrainersView: data?.trainersView ?? false,
    TrainersCreateDelete: data?.trainersCreateDelete ?? false,
    TrainersEdit: data?.trainersEdit ?? false,

    CoursesView: data?.coursesView ?? false,
    CoursesCreateDelete: data?.coursesCreateDelete ?? false,
    CoursesEdit: data?.coursesEdit ?? false,
    DateTimesView: data?.dateTimesView ?? false,
    DateTimesEdit: data?.dateTimesEdit ?? false,
    AppointmentsView: data?.appointmentsView ?? false,
    AppointmentsCreateDelete: data?.appointmentsCreateDelete ?? false,
    AppointmentsEdit: data?.appointmentsEdit ?? false,

    InvoicesView: data?.invoicesView ?? false,
    InvoicesEdit: data?.invoicesEdit ?? false,
    InvoicePositionsView: data?.invoicePositionsView ?? false,
    InvoicePositionsEdit: data?.invoicePositionsEdit ?? false,
    InvoiceRunsView: data?.invoiceRunsView ?? false,
    InvoiceRunsCreateDelete: data?.invoiceRunsCreateDelete ?? false,
    TrainerPayrollsView: data?.trainerPayrollsView ?? false,
    TrainerPayrollsEdit: data?.trainerPayrollsEdit ?? false,
    DirectDebitViewCreate: data?.directDebitViewCreate ?? false,

    AttendeesView: data?.attendeesView ?? false,
    AttendeesCreateDelete: data?.attendeesCreateDelete ?? false,
    AttendeesEdit: data?.attendeesEdit ?? false,
    InterestedView: data?.interestedView ?? false,
    InterestedCreateDelete: data?.interestedCreateDelete ?? false,
    InterestedEdit: data?.interestedEdit ?? false,

    StatisticsViewCreate: data?.statisticsViewCreate ?? false,
    MyCompanyViewEdit: data?.myCompanyViewEdit ?? false,
    CompanySubscriptionsViewEdit: data?.companySubscriptionsViewEdit ?? false,
    SettingsViewEdit: data?.settingsViewEdit ?? false,

    ReferencesView: data?.referencesView ?? false,
    TariffsCreateDelete: data?.tariffsCreateDelete ?? false,
    TariffsEdit: data?.tariffsEdit ?? false,
    DepartmentsCreateDelete: data?.departmentsCreateDelete ?? false,
    DepartmentsEdit: data?.departmentsEdit ?? false,
    MembershipTypesCreateDelete: data?.membershipTypesCreateDelete ?? false,
    MembershipTypesEdit: data?.membershipTypesEdit ?? false,
    MemberStatusesCreateDelete: data?.memberStatusesCreateDelete ?? false,
    MemberStatusesEdit: data?.memberStatusesEdit ?? false,
    CostsCreateDelete: data?.costsCreateDelete ?? false,
    CostsEdit: data?.costsEdit ?? false,
    LicencesCreateDelete: data?.licencesCreateDelete ?? false,
    LicencesEdit: data?.licencesEdit ?? false,
    SkillsCreateDelete: data?.skillsCreateDelete ?? false,
    SkillsEdit: data?.skillsEdit ?? false,
    CharacteristicsCreateDelete: data?.characteristicsCreateDelete ?? false,
    CharacteristicsEdit: data?.characteristicsEdit ?? false,
    EquipmentsCreateDelete: data?.equipmentsCreateDelete ?? false,
    EquipmentsEdit: data?.equipmentsEdit ?? false,
    AttendeeRolesEdit: data?.attendeeRolesEdit ?? false,
    AttendeeRolesCreateDelete: data?.attendeeRolesCreateDelete ?? false,
  };
}

function parse(
  data?: Partial<ApplicationUserPermissions>
): ApplicationUserPermissions {
  return {
    id: data?.id || CONST.emptyGuid,
    applicationUserId: data?.applicationUserId || CONST.emptyGuid,
    companyId: data?.companyId || CONST.emptyGuid,

    homeConflictsViewEdit: data?.homeConflictsViewEdit ?? false,
    homeTodoViewEdit: data?.homeTodoViewEdit ?? false,
    homeNewsView: data?.homeNewsView ?? false,
    homeNewsCreateDelete:
      (data?.homeNewsCreateDelete ?? false) && (data?.homeNewsView ?? false),
    homeNewsEdit:
      (data?.homeNewsEdit ?? false) && (data?.homeNewsView ?? false),
    homeReportsView: data?.homeReportsView ?? false,
    homeCalendarEdit: data?.homeCalendarEdit ?? false,
    homeCalendarChatUse: data?.homeCalendarChatUse ?? false,

    locationsView: data?.locationsView ?? false,
    locationsCreateDelete:
      (data?.locationsCreateDelete ?? false) && (data?.locationsView ?? false),
    locationsEdit:
      (data?.locationsEdit ?? false) && (data?.locationsView ?? false),

    employeesView: data?.employeesView ?? false,
    employeesCreateDelete:
      (data?.employeesCreateDelete ?? false) && (data?.employeesView ?? false),
    employeesEdit:
      (data?.employeesEdit ?? false) && (data?.employeesView ?? false),

    trainersView: data?.trainersView ?? false,
    trainersCreateDelete:
      (data?.trainersCreateDelete ?? false) && (data?.trainersView ?? false),
    trainersEdit:
      (data?.trainersEdit ?? false) && (data?.trainersView ?? false),

    coursesView: data?.coursesView ?? false,
    coursesCreateDelete:
      (data?.coursesCreateDelete ?? false) && (data?.coursesView ?? false),
    coursesEdit: (data?.coursesEdit ?? false) && (data?.coursesView ?? false),
    dateTimesView: data?.dateTimesView ?? false,
    dateTimesEdit:
      (data?.dateTimesEdit ?? false) && (data?.dateTimesView ?? false),
    appointmentsView: data?.appointmentsView ?? false,
    appointmentsCreateDelete:
      (data?.appointmentsCreateDelete ?? false) &&
      (data?.appointmentsView ?? false),
    appointmentsEdit:
      (data?.appointmentsEdit ?? false) && (data?.appointmentsView ?? false),

    invoicesView: data?.invoicesView ?? false,
    invoicesEdit:
      (data?.invoicesEdit ?? false) && (data?.invoicesView ?? false),
    invoicePositionsView: data?.invoicePositionsView ?? false,
    invoicePositionsEdit:
      (data?.invoicePositionsEdit ?? false) &&
      (data?.invoicePositionsView ?? false),
    invoiceRunsView: data?.invoiceRunsView ?? false,
    invoiceRunsCreateDelete:
      (data?.invoiceRunsCreateDelete ?? false) &&
      (data?.invoiceRunsView ?? false),
    trainerPayrollsView: data?.trainerPayrollsView ?? false,
    trainerPayrollsEdit:
      (data?.trainerPayrollsEdit ?? false) &&
      (data?.trainerPayrollsView ?? false),
    directDebitViewCreate: data?.directDebitViewCreate ?? false,

    attendeesView: data?.attendeesView ?? false,
    attendeesCreateDelete:
      (data?.attendeesCreateDelete ?? false) && (data?.attendeesView ?? false),
    attendeesEdit:
      (data?.attendeesEdit ?? false) && (data?.attendeesView ?? false),
    interestedView: data?.interestedView ?? false,
    interestedCreateDelete:
      (data?.interestedCreateDelete ?? false) &&
      (data?.interestedView ?? false),
    interestedEdit:
      (data?.interestedEdit ?? false) && (data?.interestedView ?? false),

    statisticsViewCreate: data?.statisticsViewCreate ?? false,
    myCompanyViewEdit: data?.myCompanyViewEdit ?? false,
    companySubscriptionsViewEdit: data?.companySubscriptionsViewEdit ?? false,
    settingsViewEdit: data?.settingsViewEdit ?? false,

    referencesView: data?.referencesView ?? false,
    tariffsCreateDelete:
      (data?.tariffsCreateDelete ?? false) && (data?.referencesView ?? false),
    tariffsEdit:
      (data?.tariffsEdit ?? false) && (data?.referencesView ?? false),
    departmentsCreateDelete:
      (data?.departmentsCreateDelete ?? false) &&
      (data?.referencesView ?? false),
    departmentsEdit:
      (data?.departmentsEdit ?? false) && (data?.referencesView ?? false),
    membershipTypesCreateDelete:
      (data?.membershipTypesCreateDelete ?? false) &&
      (data?.referencesView ?? false),
    membershipTypesEdit:
      (data?.membershipTypesEdit ?? false) && (data?.referencesView ?? false),
    memberStatusesCreateDelete:
      (data?.memberStatusesCreateDelete ?? false) &&
      (data?.referencesView ?? false),
    memberStatusesEdit:
      (data?.memberStatusesEdit ?? false) && (data?.referencesView ?? false),
    costsCreateDelete:
      (data?.costsCreateDelete ?? false) && (data?.referencesView ?? false),
    costsEdit: (data?.costsEdit ?? false) && (data?.referencesView ?? false),
    licencesCreateDelete:
      (data?.licencesCreateDelete ?? false) && (data?.referencesView ?? false),
    licencesEdit:
      (data?.licencesEdit ?? false) && (data?.referencesView ?? false),
    skillsCreateDelete:
      (data?.skillsCreateDelete ?? false) && (data?.referencesView ?? false),
    skillsEdit: (data?.skillsEdit ?? false) && (data?.referencesView ?? false),
    characteristicsCreateDelete:
      (data?.characteristicsCreateDelete ?? false) &&
      (data?.referencesView ?? false),
    characteristicsEdit:
      (data?.characteristicsEdit ?? false) && (data?.referencesView ?? false),
    equipmentsCreateDelete:
      (data?.equipmentsCreateDelete ?? false) &&
      (data?.referencesView ?? false),
    equipmentsEdit:
      (data?.equipmentsEdit ?? false) && (data?.referencesView ?? false),
    attendeeRolesEdit:
      (data?.attendeeRolesEdit ?? false) && (data?.referencesView ?? false),
    attendeeRolesCreateDelete:
      (data?.attendeeRolesCreateDelete ?? false) &&
      (data?.referencesView ?? false),
  };
}

export function getDefaultPermissions(
  authorities: string[]
): ApplicationUserPermissions {
  const adminOrManager =
    authorities.includes(AUTHORITIES.ADMIN) ||
    authorities.includes(AUTHORITIES.MANAGER);
  const employee = authorities.includes(AUTHORITIES.EMPLOYEE);

  return {
    // Placeholder data
    id: CONST.emptyGuid,
    applicationUserId: CONST.emptyGuid,
    companyId: CONST.emptyGuid,

    homeConflictsViewEdit: adminOrManager || employee,
    homeTodoViewEdit: adminOrManager || employee,
    homeNewsView: true,
    homeNewsCreateDelete: adminOrManager || employee,
    homeNewsEdit: adminOrManager || employee,
    homeReportsView: adminOrManager || employee,
    homeCalendarEdit: true,
    homeCalendarChatUse: true,

    locationsView: true,
    locationsCreateDelete: adminOrManager,
    locationsEdit: adminOrManager,

    employeesView: adminOrManager || employee,
    employeesCreateDelete: adminOrManager,
    employeesEdit: adminOrManager,

    trainersView: true,
    trainersCreateDelete: adminOrManager,
    trainersEdit: adminOrManager || employee,

    coursesView: true,
    coursesCreateDelete: adminOrManager || employee,
    coursesEdit: adminOrManager || employee,
    dateTimesView: adminOrManager || employee,
    dateTimesEdit: adminOrManager || employee,
    appointmentsView: true,
    appointmentsCreateDelete: adminOrManager || employee,
    appointmentsEdit: adminOrManager || employee,

    invoicesView: adminOrManager || employee,
    invoicesEdit: adminOrManager || employee,
    invoicePositionsView: adminOrManager || employee,
    invoicePositionsEdit: adminOrManager || employee,
    invoiceRunsView: adminOrManager || employee,
    invoiceRunsCreateDelete: adminOrManager || employee,
    trainerPayrollsView: adminOrManager || employee,
    trainerPayrollsEdit: adminOrManager || employee,
    directDebitViewCreate: adminOrManager,

    attendeesView: true,
    attendeesCreateDelete: adminOrManager || employee,
    attendeesEdit: adminOrManager || employee,
    interestedView: true,
    interestedCreateDelete: true,
    interestedEdit: true,

    statisticsViewCreate: adminOrManager,
    myCompanyViewEdit: adminOrManager,
    companySubscriptionsViewEdit: adminOrManager,
    settingsViewEdit: adminOrManager,

    referencesView: adminOrManager,
    tariffsCreateDelete: adminOrManager,
    tariffsEdit: adminOrManager,
    departmentsCreateDelete: adminOrManager,
    departmentsEdit: adminOrManager,
    membershipTypesCreateDelete: adminOrManager,
    membershipTypesEdit: adminOrManager,
    memberStatusesCreateDelete: adminOrManager,
    memberStatusesEdit: adminOrManager,
    costsCreateDelete: adminOrManager,
    costsEdit: adminOrManager,
    licencesCreateDelete: adminOrManager,
    licencesEdit: adminOrManager,
    skillsCreateDelete: adminOrManager,
    skillsEdit: adminOrManager,
    characteristicsCreateDelete: adminOrManager,
    characteristicsEdit: adminOrManager,
    equipmentsCreateDelete: adminOrManager,
    equipmentsEdit: adminOrManager,
    attendeeRolesCreateDelete: adminOrManager,
    attendeeRolesEdit: adminOrManager,
  };
}

export default {
  parse,
  toAPI: toAPI,
};
